import React, { useContext } from 'react';
import { Card, Box } from '@mui/material';
import SubscriberAgreement from 'Components/Doc/SubscriberAgreement/index';
import { AppContext } from 'Context';
import { V2SettingsShell } from '../../_shared/V2SettingsShell';

export const SubscriberAgreementSettingsV2 = () => {
  const { langText } = useContext(AppContext);
  const subscriberText = langText?.settings?.subscriber;
  return (
    <V2SettingsShell title={subscriberText?.title || 'Subscriber Agreement'}>
      <Card sx={{ p: { xs: 2.5, md: 4 } }}>
        <Box sx={{ '& *': { color: 'text.primary' } }}>
          <SubscriberAgreement />
        </Box>
      </Card>
    </V2SettingsShell>
  );
};
